import { render } from "./DiagnosisScreenList.vue?vue&type=template&id=66f0967d&scoped=true"
import script from "./DiagnosisScreenList.vue?vue&type=script&lang=js"
export * from "./DiagnosisScreenList.vue?vue&type=script&lang=js"

import "./DiagnosisScreenList.vue?vue&type=style&index=0&id=66f0967d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66f0967d"]])

export default __exports__